import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useSpaceQuery = ({ id }) => {
  return useQuery({
    queryKey: QUERY_KEYS.spaceById(id),
    queryFn: () => {
      return query({
        query: 'getSpace',
        variables: { id }
      })
    },
    enabled: !!id,
    refetchOnWindowFocus: true
  })
}
